import {Vue} from 'ui.vue';


import './BxmakerAuthuserphoneEnterReg.styl';


import './BxmakerAuthuserphoneEnterSmsCode';
import './BxmakerAuthuserphoneEnterUserCall';
import './BxmakerAuthuserphoneEnterBotCall';
import './BxmakerAuthuserphoneEnterBotSpeech';
import './BxmakerAuthuserphoneEnterRegForm';


Vue.component('BxmakerAuthuserphoneEnterReg', {
    name: 'BxmakerAuthuserphoneEnterReg',
    data() {
        return {};
    },
    computed: {},
    methods: {

    },

    template: `
            <div class="bxmaker-authuserphone-enter-reg"  >
                
                 <BxmakerAuthuserphoneHeader class="bxmaker-authuserphone-enter-reg__title" >
                    {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REGISTRATION_TITLE}}
                 </BxmakerAuthuserphoneHeader>  
                
                                              
                 <BxmakerAuthuserphoneEnterRegForm 
                    v-show="!$root.isShowConfirmation" 
                 />   
                                        
                 <BxmakerAuthuserphoneEnterSmsCode  
                     v-show="$root.isNeedShowConfirmationSmsCode"                                    
                 /> 
                    
                 <BxmakerAuthuserphoneEnterUserCall  
                     v-show="$root.isNeedShowConfirmationUserCall"   
                 /> 
                    
                 <BxmakerAuthuserphoneEnterBotCall 
                      v-show="$root.isNeedShowConfirmationBotCall"                 
                 />  
                 
                 <BxmakerAuthuserphoneEnterBotSpeech 
                      v-show="$root.isNeedShowConfirmationBotSpeech"                 
                 />  
                 
                    
                 <div class="bxmaker-authuserphone-enter-reg__change-confirm" v-if="$root.isNeedShowChangeConfirmation"  >
                      <BxmakerAuthuserphoneLink @onClick="$root.changeConfirmationType" >
                         {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_CHANGE_CONFIRM_TYPE}}   
                      </BxmakerAuthuserphoneLink> 
                 </div>   
                    
                 <div class="bxmaker-authuserphone-enter-reg__toauth" v-if="!$root.isShowConfirm">
                      <BxmakerAuthuserphoneLink @onClick="$root.toAuth" >
                             {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_TO_AUTH}}   
                     </BxmakerAuthuserphoneLink> 
                 </div>   
                
                             
            </div>
        `,
});